<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ $t("Mission") }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#/newsurvey">
                  <div class="photo">
                    <img :src="sitesurvey" alt="sitesurvey" />
                  </div>
                  <span class="sidebar-normal">{{
                    $t("Create Site Survey")
                  }}</span>
                </a>
              </li>
              <li>
                <a href="#/mission">
                  <div class="photo">
                    <img :src="missions" alt="missions" />
                  </div>
                  <span class="sidebar-normal">{{ $t("Missions") }}</span>
                </a>
              </li>
              <li>
                <a href="#/sms">
                  <div class="photo">
                    <img :src="airsafety" alt="airsafety" />
                  </div>
                  <span class="sidebar-normal">{{
                    $t("Air Safety Reports")
                  }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    CollapseTransition
  },
  props: {
    avatar: {
      type: String,
      default: "./img/Mission.png"
    },
    sitesurvey: {
      type: String,
      default: "./img/SiteSurvey.png"
    },
    missions: {
      type: String,
      default: "./img/missions.png"
    },
    airsafety: {
      type: String,
      default: "./img/airsafety.png"
    }
  },
  data() {
    return {
      isClosed: true
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
